import { VStack } from "@/components/ui/vstack";
import { View } from "@/components/ui/view";
import { Text } from "@/components/ui/text";
import React from 'react';
import { useDispatch } from 'react-redux'
import i18n from 'i18n-js';
import BasicButton from "../../components/basic/BasicButton";
import CancelButton from "../../components/basic/CancelButton";
import { switchScreen } from "../../hooks/navigate";
import { demoLogin } from "../../stores/mainSlice";

export default function ModalDemo({ navigation }) {
    const dispatch = useDispatch()

    return (
        <View className="flex-1 bg-[#00000050] justify-center">
            <VStack space='lg' className="m-3 bg-secondary-50 px-4 py-5 rounded-[5px]">
                <Text bold className="text-2xl text-secondary-900 bg-secondary-50">{i18n.t('login.demoTitle')}</Text>
                <Text className="text-black font-[400] text-xl">{i18n.t('login.demoInfo')}</Text>
                <BasicButton onPress={() => { dispatch(demoLogin()) }} text={i18n.t('login.demoRun')}/>
                <CancelButton onPress={() => { switchScreen(navigation, 'BACK') }} text={i18n.t('login.cancel')}/>
            </VStack>
        </View>
    );
}
